// Comment: Uses https://github.com/bsonntag/react-use-countdown + https://github.com/sindresorhus/parse-ms

import { useEffect, useState } from 'react'

const useCountdown = (getDeadline, options = {}) => {
    // @ts-ignore
    const { intervalTime = 1000, now = () => Date.now(), resetCountdownTrigger } = options

    // @ts-ignore
    const getTimeSpanUntilDeadline = () => new Date(getDeadline()) - new Date(now())

    const [timeLeft, setTimeLeft] = useState(getTimeSpanUntilDeadline)

    useEffect(() => {
        setTimeLeft(getTimeSpanUntilDeadline)
    }, [resetCountdownTrigger])

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(current => {
                if (current <= 0) {
                    clearInterval(interval)

                    return 0
                }

                return current - intervalTime
            })
        }, intervalTime)

        return () => clearInterval(interval)
    }, [intervalTime])

    const addLeadingZero = time => (time > 0 ? String(time).padStart(2, '0') : '00')

    return {
        days: addLeadingZero(Math.floor(timeLeft / 86400000)),
        hours: addLeadingZero(Math.floor(timeLeft / 3600000) % 24),
        minutes: addLeadingZero(Math.floor(timeLeft / 60000) % 60),
        seconds: addLeadingZero(Math.floor(timeLeft / 1000) % 60),
        milliseconds: addLeadingZero(Math.floor(timeLeft) % 1000),
    }
}

export { useCountdown }
